import api from "../../../../lib/api";
import { IVendorCreate, IVendorListSearch, IEditVendorPayload } from "../../../../types/master/vendorInterface";

export const createVendorApi = async (data: IVendorCreate) => {
  return await api.post(`/vendor`, data);
};

export const getVendorListApi = async (data: IVendorListSearch) => {
  return await api.get(`/vendor/${data.page}/${data?.pageLimit}?search=${data?.search??""}`)
}

export const getVendorDataByIdApi = async (id: number) => {
  return await api.get(`/vendor/${id}`)
}

export const editVendorDataByIdApi = async (payload: IEditVendorPayload) => {
  return await api.put(`/vendor/${payload.id}`, payload.data);
};